<template>
  <div
    class="row"
    v-if="borrow"
  >
    <div class="col-md-12">
      <template v-if="borrow.type === 'Purchasing'">
        <installment-form :editable="editable" />
      </template>
      <template v-else-if="borrow.type === 'Pawn'">
        <pawn-form :editable="editable" />
      </template>
      <template v-else>
        <personal-pay-day-form :editable="editable" />
      </template>
    </div>
  </div>
</template>

<script>
import PersonalPayDayForm from '@/views/borrows/_components/forms/PersonalPayDayForm'
import InstallmentForm from '@/views/borrows/_components/forms/InstallmentForm'
import PawnForm from '@/views/borrows/_components/forms/PawnForm'

export default {
  name: 'Form',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PawnForm,
    InstallmentForm,
    PersonalPayDayForm
  },
  data () {
    return {
      borrow: null
    }
  },
  methods: {
    async getBorrow () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/get-borrow', {
        id: this.$route.params.id
      }).then((response) => {
        if (response.data && response.data.data) {
          this.borrow = response.data.data
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  },
  async mounted () {
    await this.getBorrow()
  }
}
</script>

<style scoped>

</style>
